export default "__VITE_ASSET__SkUKdJqK__"